export const ThemeStyle = {
  MODERN: 'modern',
  STANDARD: 'standard',
};
export const ThemeStyleRadius = {
  MODERN: 30,
  STANDARD: 16,
};
export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
};
export const LayoutType = {
  FULL_WIDTH: 'full-width',
  BOXED: 'boxed',
  FRAMED: 'framed',
};
export const MenuStyle = {
  DEFAULT: 'default',
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  ROUNDED_REVERSE: 'rounded-reverse',
  CURVED_MENU: 'curved-menu',
};
export const LayoutDirection = {
  RTL: 'rtl',
  LTR: 'ltr',
};
export const NavStyle = {
  DEFAULT: 'default',
  BIT_BUCKET: 'bit_bucket',
  STANDARD: 'standard',
  DRAWER: 'drawer',
  MINI: 'mini',
  MINI_SIDEBAR_TOGGLE: 'mini-sidebar-onToggleSidebar',
  HEADER_USER: 'user-header',
  HEADER_USER_MINI: 'user-mini-header',
  H_DEFAULT: 'h-default',
  HOR_HEADER_FIXED: 'hor-header-fixed',
  HOR_DARK_LAYOUT: 'hor-dark-layout',
};
export const FooterType = {
  FIXED: 'fixed',
  FLUID: 'fluid',
};
export const HeaderType = {
  FLUID: 'fluid',
  FIXED: 'fixed',
};
export const RouteTransition = {
  NONE: 'none',
  alpha: 'alpha',
  SLIDE_LEFT: 'slideLeft',
  SLIDE_RIGHT: 'slideRight',
  SLIDE_UP: 'slideUp',
  SLIDE_DOWN: 'slideDown',
};
export const Fonts = {
  LIGHT: '300',
  REGULAR: '400',
  MEDIUM: '500',
  SEMI_BOLD: '600',
  BOLD: '700',
};

export const AuthType = {
  FIREBASE: 'firebase',
  AWS_COGNITO: 'aws_cognito',
  AUTH0: 'auth0',
  JWT_AUTH: 'jwt_auth',
};

export const Colors = {
  primary: '#6896BB',
  secondary: '#ffcdd2',
  success: '#42EA89',
  warning: '#FFC657',
  danger: '#FF6F61',
  info: '#1868AB',
  white: '#fff',
  black: '#000',
  neutral80: '#666666',
  neutral20: '#797979',
  secondaryDark: '#66656C',
  tosca: '#38B2AC',
}

export const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const numberWithCommas = (x) => {
  return x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
}

export const stringAvatar = (name, width = null, height = null) => {
  if (name)
    return {
      sx: {
        bgcolor: stringToColor(name),
        width: width ? width : 48,
        height: height ? height : 48,
        cursor: 'pointer'
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1]?.[0] === undefined ? '' : name.split(' ')[1]?.[0]}`,
    };
  else return {
    sx: {
      bgcolor: (theme) => theme.palette.primary.main,
      width: width ? width : 48,
      height: height ? height : 48,
    }
  }
}

export const checkValue = (value) => {
  if (value === null || value === '' || value === undefined || value === '0.0') {
    return '-'
  } else {
    return value
  }
}

export const findDataFromKeyAttr = (key = '', array = []) => {
  if (Array.isArray(array) && array.length > 0) {
    return array.find((item) => item.key === key).value ?? '-'
  }
}

export const debounce = (func, wait) => {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  }
}

export const formatDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice();
  return `${day}-${month}-${year}`;
};

export const optionLimit = [
  { id: 10, label: 10 },
  { id: 30, label: 30 },
  { id: 50, label: 50 },
]

export const SPACING = 4

export const AuthSSO = process.env.REACT_APP_AuthSSO || 'https://auth.kubekkp.coofis.com/oidc/extoken?redirect=https://sipeg.kubekkp.coofis.com'

// API CONSTANTS
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://sipeg.kubekkp.coofis.com/api/';

// LOGOUT URL
const LOG_OUT_URL = process.env.REACT_APP_LOG_OUT || 'https://auth.kubekkp.coofis.com/token/logout/';

// CHANGE ROLE
const UPDATE_ROLE_USER = BASE_URL + 'pegawai-update-group/$nip/'

// MASTER DATA
const GET_LIST_PRODI = BASE_URL + 'pendidikan/option/?get_tingkat_pendidikan=$tingkat';
const GET_LIST_CLUSTER = BASE_URL + 'cluster/option/';
const GET_LIST_SUBCLUSTER = BASE_URL + 'cluster/option/?get_cluster_pendidikan=$cluster';
const GET_LIST_PENDIDIKAN_ID = BASE_URL + 'pendidikan/options/';
const GET_LIST_PRODI_BY_PENDIDIKAN = BASE_URL + 'prodi/option/?pendidikan_min=$min&pendidikan_max=$max';  // ada query pendidikan_min dan pendidikan_max 
const GET_LIST_GOLONGAN = BASE_URL + 'golongan/option/';
const GET_LIST_ESELON = BASE_URL + 'eselon/';
const GET_LIST_TIPE_JABATAN = BASE_URL + 'tipe-jabatan/';
const GET_LIST_JABFUNG = BASE_URL + 'jabfungfilter/option/';
const GET_LIST_GAJI = BASE_URL + 'gaji-pokok/choice/';
const GET_LIST_GOLONGAN_CHOICE = BASE_URL + 'pns-golongan/option/';
const GET_LIST_TINGKAT_PENDIDIKAN = BASE_URL + 'pendidikan-tingkat/option/';
const GET_CREATE_SEKOLAH = BASE_URL + 'sekolah-list/';
const GET_UPDATE_SEKOLAH = BASE_URL + 'sekolah-list/$id';
const GET_DELETE_SEKOLAH = BASE_URL + 'sekolah-list/$id';
const GET_OPTION_SHIFT = BASE_URL + 'pegawai-jadwal-kerja/jam-kerja/option/';
const GET_OPTION_JURUSAN = BASE_URL + 'jurusan-data/option/';
const GET_OPTION_SEKOLAH = BASE_URL + 'sekolah/option/?tingkat=';
const GET_JENIS_DIKLAT_OPTION = BASE_URL + 'diklat-jenis/option/';
const GET_KATEGORI_DIKLAT_OPTION = BASE_URL + 'diklat-kategori/option/';
// const GET_ESELON_OPTION = BASE_URL + 'eselon-option/';
const GET_ESELON_OPTION = BASE_URL + 'eselon-option-v2/';
const GET_PEGAWAI_PENSIUN_OPTION = BASE_URL + 'pegawai-pensiun/jenis/option/';
const GET_OPTION_BIDANG_KEAHLIAN = BASE_URL + 'bidang-keahlian/';
const GET_OPTION_PROGRAM_KERJA = BASE_URL + 'program-kerja/type/option';
const GET_OPTION_STATUS_PROGRAM_KERJA = BASE_URL + 'program-kerja/status/option';
const GET_OPTION_INTERVENSI_PROGRAM_KERJA = BASE_URL + 'program-kerja/intervensi/option';

// DATA PEGAWAI MASTER DATA
const PROFILE_PEGAWAI = BASE_URL + 'pegawai/';
const GET_LIST_PEGAWAI = BASE_URL + 'pegawai/?status='
const GET_UPDATE_DELETE_DETAIL_PEGAWAI = BASE_URL + 'pegawai/$id/';
const GET_CREATE_KATEGORI_ASN = BASE_URL + 'kategori-asn/';
const GET_CREATE_JENIS_KELAMIN = BASE_URL + 'jenis_kelamin'
const GET_UPDATE_DELETE_DETAIL_KATEGORI_ASN = BASE_URL + 'kategori-asn/$id/';
// const GET_CREATE_STATUS_PEGAWAI = BASE_URL + 'status-pegawai-v2/';
// const GET_UPDATE_DELETE_DETAIL_STATUS_PEGAWAI = BASE_URL + 'status-pegawai/$id/';
const GET_CREATE_STATUS_PEGAWAI = BASE_URL + 'status-pegawai-v2/';
const GET_UPDATE_DELETE_DETAIL_STATUS_PEGAWAI = BASE_URL + 'status-pegawai-v2/$id/';
const GET_CREATE_PENGHARGAAN_SLKS = BASE_URL + 'penghargaan-slks/';
const GET_UPDATE_DELETE_DETAIL_PENGHARGAAN_SLKS = BASE_URL + 'penghargaan-slks/$id';
const GET_CREATE_GENDER = BASE_URL + 'jenis-kelamin/';
const GET_UPDATE_DELETE_DETAIL_GENDER = BASE_URL + 'jenis-kelamin/$id';
const GET_CREATE_KAWIN = BASE_URL + 'perkawinan/';
const GET_UPDATE_DELETE_DETAIL_KAWIN = BASE_URL + 'perkawinan/$id';
const GET_CREATE_AGAMA = BASE_URL + 'agama/';
const GET_UPDATE_DELETE_DETAIL_AGAMA = BASE_URL + 'agama/$id';
const GET_CREATE_GOLDAR = BASE_URL + 'golongan-darah';
const GET_UPDATE_DELETE_DETAIL_GOLDAR = BASE_URL + 'golongan-darah/$id';
const GET_CREATE_UNKER = BASE_URL + 'unker/';
const GET_UNKER_GENERAL = BASE_URL + 'unker/?type=dash';
const GET_CREATE_JABATAN = BASE_URL + 'jabatan/';
const GET_CREATE_TIM_KERJA = BASE_URL + 'tim-kerja/';
const GET_CREATE_FORMASI_CPNS = BASE_URL + 'cpns-formasi/';
const GET_CREATE_CPNS_STATUS_FORMASI = BASE_URL + 'cpns-status-formasi/';
const GET_CREATE_CPNS_FUNGSIONAL_TIPE = BASE_URL + 'cpns-fungsional-tipe/';
const GET_CREATE_CPNS_FUNGSIONAL_KODE = BASE_URL + 'cpns-fungsional-kode/';
const GET_SEARCH_PEGAWAI = BASE_URL + 'pegawai/option/?search=$name'
const GET_LOKASI = BASE_URL + 'lokasi/option/';
const GET_KATEGORI_PP_PELANGGARAN = BASE_URL + 'pegawai-hukdis/kategori/';
const GET_CREATE_JENIS_CUTI = BASE_URL + 'jenis-cuti/';
const GET_CREATE_UPDATE_DELETE_JURUSAN = BASE_URL + 'jurusan/'
const GET_CREATE_UPDATE_DELETE_UNIVERSITAS = BASE_URL + 'universitas/'
const GET_CREATE_UPDATE_DELETE_HARI_LIBUR = BASE_URL + 'hari-libur/'
const GET_LIST_NEGARA = BASE_URL + 'negara/';
const GET_LIST_UNKER = BASE_URL + 'unker/';
const GET_LIST_JAM_KERJA = BASE_URL + 'jam-kerja/';
const ACTIVE_DEACTIVE_NEGARA = BASE_URL + 'negara/state/'
const GET_PROVINSI_BY_NEGARA = BASE_URL + 'provinsi/';
const GET_KOTA_BY_PROVINSI = BASE_URL + 'kota/?provinsi=$provinsi';
const GET_KECAMATAN_BY_KOTA = BASE_URL + 'kecamatan/?kota=$kota';
const GET_KELURAHAN_BY_KECAMATAN = BASE_URL + 'kelurahan/?kecamatan=$kecamatan';
const GET_LIST_JABFUNG_GENERAL = BASE_URL + 'jabatanfungsional/option/';
const GET_UNKER_CHOICE = BASE_URL + 'unit-kerja/choice/';
const GET_JABATAN_BY_UNKER = BASE_URL + 'jabatan/choice/';
const GET_HUKDIS_CHOICE = BASE_URL + 'pegawai-hukdis/option/';
const CRUD_DIKLAT_JABATAN = BASE_URL + 'diklat-jabatan/';
const CRUD_PROVINSI = BASE_URL + 'provinsi-list/';
const CRUD_KOTA = BASE_URL + 'kota-list/';
const CRUD_KECAMATAN = BASE_URL + 'kecamatan/';
const CRUD_TINGKAT_PENDIDIKAN = BASE_URL + 'pendidikan-tingkat-list/'
const CRUD_KELURAHAN = BASE_URL + 'kelurahan/';
const CRUD_BAHASA = BASE_URL + 'bahasa/';
const GET_CREATE_SMP = BASE_URL + 'sekolah-list/';
const GET_CREATE_SD = BASE_URL + 'sekolah-list/';
const UPDATE_DELETE_SMP = BASE_URL + 'sekolah-list/$id/'
const UPDATE_DELETE_SD = BASE_URL + 'sekolah-list/$id/'
const CRUD_JABATAN = BASE_URL + 'jabatan/';
const CRUD_KEDUDUKAN = BASE_URL + 'kedudukan/';
const CRUD_PP_PELANGGARAN = BASE_URL + 'pp-pelanggaran/';
// MASTERDATA V2
const GET_CREATE_KATEGORI_ASN_V2 = BASE_URL + 'kategori-asn-v2/option/';
const GET_OPTION_STATUS_PEGAWAI = BASE_URL + 'pegawai-status-aktif-option/';

// DATA PEGAWAI
const GET_DATA_INFO_PASANGAN_PEGAWAI = BASE_URL + 'me/info/';
const GET_CREATE_UPDATE_DELETE_DATA_ANAK = BASE_URL + 'me/anak/';
const GET_CREATE_UPDATE_DELETE_DATA_KELUARGA = BASE_URL + 'me/keluarga/';
const UPDATE_PEGAWAI_KONTRAK = BASE_URL + 'pegawai-kontrak-data-pokok/';
const UPDATE_PEGAWAI_KONTRAK_PENDIDIKAN = BASE_URL + 'pegawai-kontrak-data-pokok/';
const CRUD_DIKLAT_KURSUS_PEGAWAI = BASE_URL + 'diklat-kursus/';
const READ_CREATE_PEGAWAI_KEAHLIAN = BASE_URL + 'pegawai-keahlian/';
const UPLOAD_ATTACHMENT_PEGAWAI_KEAHLIAN = BASE_URL + 'pegawai-documents/';
const UPDATE_STATUS_PEGAWAI = BASE_URL + 'pegawai-status-aktif/$nip/';
const GET_STATUS_PEGAWAI_BY_NIP = BASE_URL + 'pegawai-status-aktif/$nip/';

// DATA PEGAWAI ASN ADMIN & OPERATOR
const GET_CREATE_DATA_ANAK_BY_NIP = BASE_URL + 'pegawai-anak/';
const UPDATE_DELETE_DATA_ANAK_BY_NIP = BASE_URL + 'pegawai-anak/$id/=';
const GET_CREATE_UPDATE_DELETE_DATA_KELUARGA_ADMINISTRATOR = BASE_URL + 'pegawai-keluarga/';
const GET_CREATE_UPDATE_DELETE_DATA_PASANGAN_ADMINISTRATOR = BASE_URL + 'pegawai-pasangan/';
const GET_CREATE_DATA_TUGAS_IZIN_BELAJAR = BASE_URL + 'laporan-khusus/rekap-tugas-izin-belajar/';
const GET_CREATE_PEGAWAI_AKAN_PENSIUN = BASE_URL + 'laporan-khusus/rekap-pegawai-akan-pensiun/';
const GET_CREATE_DATA_UJIAN_DINAS = BASE_URL + 'diklat-ujian-dinas/';
const GET_DATA_PEGAWAI_KONTRAK = BASE_URL + 'pegawai-kontrak/';
const GET_CREATE_UPDATE_DELETE_DATA_PEGAWAI_ADMINISTRATOR = BASE_URL + 'pegawai-drh/';
const GET_CREATE_DATA_PEGAWAI_KONTRAK = BASE_URL + 'pegawai-kontrak-data-pokok/';
const GET_CREATE_DATA_PEGAWAI_POKOK_ASN_ADMINISTRATOR = BASE_URL + 'pegawai-data-pokok/';
const ADD_JABATAN_BY_NIP = BASE_URL + 'pegawai-jabatan/';
const CRUD_HUKDIS = BASE_URL + 'pegawai-hukdis/$nip/';
const ADD_KP4 = BASE_URL + 'pegawai-kp4/';
const GET_CREATE_UPDATE_DELETE_DATA_KGB_ADMINISTRATOR = BASE_URL + 'pegawai-kgb/';
const CRUD_DIKLAT_PERJENJANGAN = BASE_URL + 'diklat-perjenjangan/';
const GET_CREATE_UPDATE_DELETE_DATA_PENYESUAIAN_IJAZAH = BASE_URL + 'pegawai-penyesuaian-ijasah/';
const GET_CREATE_KEMAMPUAN_BAHASA_ASING = BASE_URL + 'pegawai-bahasa-asing/';
const UPDATE_DELETE_KEMAMPUAN_BAHASA_ASING = BASE_URL + 'pegawai-bahasa-asing/$id/';
const GET_CREATE_DATA_PENGHARGAAN = BASE_URL + 'pegawai-penghargaan/'
const UPDATE_DELETE_DATA_PENGHARGAAN = BASE_URL + 'pegawai-penghargaan/'
const GET_CREATE_UPDATE_DELETE_DATA_PENDIDIKAN_FORMAL = BASE_URL + 'pegawai-pendidikan/';
const CRUD_KEPANGKATAN_ADMIN = BASE_URL + 'pegawai-kepangkatan/';
const CRUD_JABATAN_ADMIN = BASE_URL + 'pegawai-jabatan/';
const UPDATE_DELETE_DATA_POKOK_PEGAWAI = BASE_URL + 'pegawai-data-pokok/'
const CRUD_PENDIDIKAN_INFORMAL = BASE_URL + 'pendidikan-informal/$nip/';
const CRUD_CLTN = BASE_URL + 'pegawai-cltn/';
const CRUD_DIKLAT = BASE_URL + 'pegawai-diklat/';
const CREATE_ADMINISTRASI_MUTASI_PENSIUN_WAFAT = BASE_URL + 'pegawai-pensiun/$nip/';

// DASHBOARD
const GET_DASHBOARD = BASE_URL + 'dashboard/graph/jumlah-asn-non-pegawai/';
const GET_TABLE_DASHBOARD = BASE_URL + 'dashboard/graph/jumlah-asn-non-pegawai/detail/';
const GET_DASHBOARD_ULTAH = BASE_URL + 'dashboard/info/ulang-tahun/?pensiun=$pensiun&page=$page';
const GET_DASHBOARD_WAFAT = BASE_URL + 'dashboard/info/meninggal/';
const SEARCH_PEGAWAI_BY_PENDIDIKAN = BASE_URL + 'search/by-pendidikan/?nama=$nama&page=$page';
const SEARCH_PEGAWAI_BY_CLUSTER = BASE_URL + 'search/by-pendidikan/?nama=$nama&page=$page';
const GET_KOMPARASI_PEGAWAI = BASE_URL + 'compare/pegawai/?nip_compare=$dataNip'
const GET_DASHBOARD_USIA = BASE_URL + 'dashboard/rentang-usia-kkp/';
const GET_SLKS_DASHBOARD = BASE_URL + 'slks/dashboard/';
const GET_DETAIL_UPT_DASHBOARD = BASE_URL + 'dashboard/maps-list/?provinsi=$provinsi&search=$nama&page=$page'
const GET_MARKER_MAPS_UPT = BASE_URL + `dashboard/maps-provinsi/`;
const GET_DASHBOARD_PROGRAM_KERJA = BASE_URL + 'program-kerja/dashboard/?periode=$periode&tahun=$tahun';
// DASHBOARD V2
const GET_DASHBOARD_V2 = BASE_URL + 'dashboard/graph/jumlah-asn-non-pegawai-v2/';
const GET_DASHBOARD_PEGAWAI_ESELON_1 = BASE_URL + 'dashboard/unit-kerja/';

// LAPORAN
const GET_NOMINATIF = BASE_URL + 'laporan/nominatif/';
const GET_LAPORAN_KEPANGKATAN = BASE_URL + 'laporan/kepangkatan/';
const GET_NAIK_GAJI_BERKALA = BASE_URL + 'laporan/naik-gaji-berkala/';
const GET_DIKLAT_PERJENJANGAN = BASE_URL + 'laporan/diklat-perjenjangan/';
const GET_SUMPAH_PEGAWAI = BASE_URL + 'laporan/sumpah-pegawai/';
const GET_PRAJABATAN = BASE_URL + 'laporan/prajabatan/';
// const GET_SLKS = BASE_URL + 'laporan/masa-kerja-skls/';
const GET_PENDIDIKAN_JURUSAN = BASE_URL + 'laporan/pendidikan-jurusan/';
const GET_REKAPITULASI_PEGAWAI = BASE_URL + 'laporan/rekapitulasi-pegawai/';
const GET_LIST_TIPE_REKAP = BASE_URL + 'rekapitulasi/option/';
const DOWNLOAD_LAPORAN = BASE_URL + 'download-data/?tipe=';
const GET_LAPORAN_JUMLAH_JABATAN_UNIT = BASE_URL + 'laporan/rekapitulasi-bagan/?unker='
const GET_LIST_PEGAWAI_LAPORAN_JUMLAH_JABATAN_UNIT = BASE_URL + 'laporan/list-rekapitulasi-bagan/'
const EXPORT_DATA_LAPORAN = BASE_URL + 'laporan/export-excel/';
const GET_SLKS = BASE_URL + 'laporan/penerimaan-penghargaan/';
const GET_OPTION_JENIS_PENGHARGAAN = BASE_URL + 'laporan/penerimaan-penghargaan-option/';
const GET_REKAPITULASI_PENGHARGAAN_ASN = BASE_URL + 'laporan/rekapitulasi-penghargaan/';

// LAPORAN JABFUNG
const GET_PEJABAT_FUNGSIONAL = BASE_URL + 'laporan/pejabat-fungsional/';
const GET_JENJANG_PEJABAT_FUNGSIONAL = BASE_URL + 'laporan/jenjang-pejabat-fungsional/';
const GET_JENJANG_PEJABAT_FUNGSIONAL_DAFTAR = BASE_URL + 'laporan/jenjang-pejabat-fungsional/daftar/';
const GET_PEGAWAI_FUNGSIONAL = BASE_URL + 'laporan/rekapitulasi-pegawai-fungsional/';

//LAPORAN KHUSUS
const GET_INFORMASI_JABATAN = BASE_URL + 'pegawai-jabatan/'

//LAPORAN GRAFIK
const GET_LAPORAN_GRAFIK = BASE_URL + 'dashboard-count/';

//DRH
const GET_DRH = BASE_URL + 'me/drh/';
const GET_DETAIL_DATA_DIRI = BASE_URL + 'me/data/';
const UPDATE_DATA_PRIBADI_DRH = BASE_URL + 'update/me/';

//KELOMPOK TALENTA
const GET_KELOMPOK_TALENTA = BASE_URL + 'pegawai-new-assessment-center/$nip/';
const POST_SYNC_SIANTER_ASSESSMENT = BASE_URL + 'pegawai-update-assessment-center/?nip=';
 const GET_STATUS_SYNC_SIANTER_ASSESSMENT = BASE_URL + 'pegawai-update-assessment-center/?task='

//PREDIKAT E-KINERJA
const GET_PREDIKAT_EKINERJA = BASE_URL + 'pegawai-laporan-kinerja-penilaian/$nip/';

// UPLOAD BERKAS
const API_DATA_BERKAS_ELEKTRONIK = BASE_URL + 'me/berkas-elektronik/';

// MANAJEMEN TIM KERJA
const GET_LIST_TIM_KERJA = BASE_URL + 'tim-kerja/';
const GET_LIST_ANGGOTA_TIM_KERJA = BASE_URL + 'tim-kerja-anggota/$id/';
const GET_OPTION_TIM_KERJA_CATEGORY = BASE_URL + 'tim-kerja-kategori-option/';
const GET_PIMPINAN_TIM_KERJA = BASE_URL + 'unit-kerja-pimpinan/$code/';

// LOGBOOK
const GET_LIST_AKTIVITAS_GENERAL = BASE_URL + 'action-log/';

// PENGATURAN OPERATOR
const GET_LIST_PEGAWAI_ROLE = BASE_URL + 'pengaturan-role/';
const GET_LIST_MENUS = BASE_URL + 'pengaturan-role/menu';
const ADD_GROUP_MENU = BASE_URL + 'pengaturan-role/group';

// MONITORING
const GET_LIST_MONITORING_OPERATOR = BASE_URL + 'siasn/?search=$search&unit_kerja=$unit_kerja'
const EXPORT_DATA_MONITORING = BASE_URL + 'siasn/excel/'
const EXPORT_DATA_MONITORING_ALL = BASE_URL + 'laporan/export/excel/monitoring-siasn/'
const GET_LIST_PROGRESS_MONITORING_ALL = BASE_URL + 'laporan/export/'

// SLKS
const GET_LIST_PEGAWAI_SLKS = BASE_URL + '/slks/?masa_kerja='

// PROGRAM KERJA OPERATOR
const CRUD_LIST_PROGRAM_KERJA = BASE_URL + 'program-kerja/';
const ADD_ATTACHMENT_PROGRAM_KERJA = BASE_URL + 'program-kerja/attachments/';

// UPDATE MANUAL DATA DRH CHECK PROGRESS
const UPDATE_MANUAL_DATA_DRH_PEGAWAI = BASE_URL + 'me/update-data-siasn-data/';
const UPDATE_MANUAL_DOKUMEN_DRH_PEGAWAI = BASE_URL + 'me/update-data-siasn-dokumen/';

// UPLOAD CSV DATA PEGAWAI ASN
const UPLOAD_CSV_PEGAWAI_ASN = BASE_URL + 'siasn/import-data/';

// PRESENSI
const GET_DASHBOARD_PRESENSI = BASE_URL + 'pegawai-presensi/';

// UMPAN BALIK 360
const GET_LIST_PENILAIAN = BASE_URL + 'assessment/tasks/';
const GET_LIST_QUESTIONS = BASE_URL + 'assessment/tasks/questions/';
const SUBMIT_PENILAIAN = BASE_URL + 'assessment/tasks/submit/';
const GENERATE_PENILAIAN = BASE_URL + 'assessment/generate-penilai-unit/';
const GET_DASHBOARD_ME = BASE_URL + 'assessment/report/dashboard/me/';
const GET_DASHBOARD_ADMIN = BASE_URL + 'assessment/report/dashboard/admin/';
const GET_LIST_REPORT_PROSES = BASE_URL + 'assessment/report/list/proses/';
const GET_LIST_REPORT_REKAP = BASE_URL + 'assessment/report/list/rekap/';
const GET_DETAIL_ASSESSMENT = BASE_URL + 'assessment/tasks/detail/';
const GET_OPTION_INDIKATOR_ASSESSMENT = BASE_URL + 'assessment/indikator-option/';
const GET_LIST_HISTORI_GENERATE = BASE_URL + 'assessment/generate-penilai-history/';
const EXPORT_LIST_REPORT_REKAP = BASE_URL + 'assessment/report/export/excel/rekap/';
const EXPORT_LIST_REPORT_PROSES = BASE_URL + 'assessment/report/export/excel/proses/';
const GET_LIST_PROGRES_EXPORT = BASE_URL + 'assessment/report/export/list/';
const GET_LIST_ROLE_AKSES = BASE_URL + 'assessment/roles/';
const UPDATE_ROLE_AKSES = BASE_URL + 'assessment/roles/$nip/';
const GET_LIST_RELATIONS = BASE_URL + 'assessment/relations/';
const GET_UPDATE_DETAIL_RELATION = BASE_URL + 'assessment/relations/$id/';
const GET_DETAIL_REPORT_PROSES = BASE_URL + 'assessment/report/list/proses/detail/$nip/?mode=';
const GET_LIST_PEGAWAI_BY_STATUS_PENILAIAN = BASE_URL + 'assessment/report/dashboard/admin/detail/?status='
// MASTER UMPAN BALIK 360
const CRUD_QUESTIONS = BASE_URL + 'assessment/questions/';
const GET_OPTION_ROLE = BASE_URL + 'assessment/role-option/';
const GET_OPTION_PEGAWAI_360 = BASE_URL + 'assessment/pegawai-option/?search=';
const GET_OPTION_ROLE_PENILAI = BASE_URL + 'assessment/role-penilai-option/';
const CRUD_QUARTER = BASE_URL + 'assessment/quarter/';
const GET_OPTION_ASSESSMENT = BASE_URL + 'assessment/assessment-option/';

export const API = {
  LOG_OUT_URL,
  UPDATE_ROLE_USER,
  PROFILE_PEGAWAI,
  GET_UPDATE_DELETE_DETAIL_PEGAWAI,
  GET_CREATE_KATEGORI_ASN,
  GET_CREATE_JENIS_KELAMIN,
  GET_UPDATE_DELETE_DETAIL_KATEGORI_ASN,
  GET_CREATE_STATUS_PEGAWAI,
  GET_UPDATE_DELETE_DETAIL_STATUS_PEGAWAI,
  GET_CREATE_PENGHARGAAN_SLKS,
  GET_UPDATE_DELETE_DETAIL_PENGHARGAAN_SLKS,
  GET_CREATE_GENDER,
  GET_UPDATE_DELETE_DETAIL_GENDER,
  GET_CREATE_KAWIN,
  GET_UPDATE_DELETE_DETAIL_KAWIN,
  GET_CREATE_AGAMA,
  GET_UPDATE_DELETE_DETAIL_AGAMA,
  GET_CREATE_GOLDAR,
  GET_UPDATE_DELETE_DETAIL_GOLDAR,
  GET_CREATE_UNKER,
  GET_UNKER_GENERAL,
  GET_CREATE_JABATAN,
  GET_CREATE_TIM_KERJA,
  GET_CREATE_FORMASI_CPNS,
  GET_CREATE_CPNS_STATUS_FORMASI,
  GET_CREATE_CPNS_FUNGSIONAL_TIPE,
  GET_CREATE_CPNS_FUNGSIONAL_KODE,
  GET_SEARCH_PEGAWAI,
  GET_DASHBOARD,
  GET_TABLE_DASHBOARD,
  GET_DASHBOARD_ULTAH,
  GET_DASHBOARD_WAFAT,
  SEARCH_PEGAWAI_BY_PENDIDIKAN,
  SEARCH_PEGAWAI_BY_CLUSTER,
  GET_KOMPARASI_PEGAWAI,
  GET_DASHBOARD_USIA,
  GET_DATA_INFO_PASANGAN_PEGAWAI,
  GET_CREATE_UPDATE_DELETE_DATA_ANAK,
  GET_CREATE_UPDATE_DELETE_DATA_KELUARGA,
  GET_CREATE_DATA_PENGHARGAAN,
  UPDATE_DELETE_DATA_PENGHARGAAN,
  GET_CREATE_KEMAMPUAN_BAHASA_ASING, //Kemampuan Bahasa asing
  UPDATE_DELETE_KEMAMPUAN_BAHASA_ASING,
  UPDATE_DELETE_DATA_POKOK_PEGAWAI,
  GET_NOMINATIF,
  GET_LAPORAN_KEPANGKATAN,
  GET_NAIK_GAJI_BERKALA,
  GET_DIKLAT_PERJENJANGAN,
  GET_SUMPAH_PEGAWAI,
  GET_SLKS,
  GET_OPTION_JENIS_PENGHARGAAN,
  GET_REKAPITULASI_PENGHARGAAN_ASN,
  GET_PRAJABATAN,
  GET_PENDIDIKAN_JURUSAN,
  GET_PEJABAT_FUNGSIONAL,
  GET_JENJANG_PEJABAT_FUNGSIONAL,
  GET_JENJANG_PEJABAT_FUNGSIONAL_DAFTAR,
  GET_PEGAWAI_FUNGSIONAL,
  GET_INFORMASI_JABATAN,
  GET_DRH,
  API_DATA_BERKAS_ELEKTRONIK,
  GET_LIST_PRODI,
  GET_LIST_CLUSTER,
  GET_CREATE_UPDATE_DELETE_DATA_KELUARGA_ADMINISTRATOR,
  GET_CREATE_UPDATE_DELETE_DATA_PASANGAN_ADMINISTRATOR,
  GET_CREATE_UPDATE_DELETE_DATA_PEGAWAI_ADMINISTRATOR,
  GET_CREATE_DATA_PEGAWAI_KONTRAK,
  GET_CREATE_DATA_PEGAWAI_POKOK_ASN_ADMINISTRATOR,
  ADD_JABATAN_BY_NIP,
  CRUD_HUKDIS,
  ADD_KP4,
  GET_CREATE_UPDATE_DELETE_DATA_KGB_ADMINISTRATOR,
  CRUD_DIKLAT_PERJENJANGAN,
  GET_CREATE_UPDATE_DELETE_DATA_PENYESUAIAN_IJAZAH,
  GET_CREATE_UPDATE_DELETE_DATA_PENDIDIKAN_FORMAL,
  CRUD_KEPANGKATAN_ADMIN,
  GET_LIST_GOLONGAN_CHOICE,
  GET_CREATE_SMP,
  GET_CREATE_SD,
  UPDATE_DELETE_SMP,
  UPDATE_DELETE_SD,
  GET_LIST_SUBCLUSTER,
  GET_LOKASI,
  GET_KATEGORI_PP_PELANGGARAN,
  GET_DETAIL_DATA_DIRI,
  GET_CREATE_JENIS_CUTI,
  GET_CREATE_UPDATE_DELETE_JURUSAN,
  GET_CREATE_UPDATE_DELETE_UNIVERSITAS,
  GET_CREATE_UPDATE_DELETE_HARI_LIBUR,
  GET_LIST_NEGARA,
  GET_LIST_UNKER,
  GET_LIST_JAM_KERJA,
  ACTIVE_DEACTIVE_NEGARA,
  GET_PROVINSI_BY_NEGARA,
  GET_KOTA_BY_PROVINSI,
  GET_KECAMATAN_BY_KOTA,
  GET_KELURAHAN_BY_KECAMATAN,
  GET_LIST_JABFUNG_GENERAL,
  GET_UNKER_CHOICE,
  GET_JABATAN_BY_UNKER,
  GET_HUKDIS_CHOICE,
  CRUD_DIKLAT_JABATAN,
  CRUD_PROVINSI,
  CRUD_KOTA,
  CRUD_KECAMATAN,
  CRUD_TINGKAT_PENDIDIKAN,
  CRUD_KELURAHAN,
  CRUD_BAHASA,
  CRUD_JABATAN,
  CRUD_KEDUDUKAN,
  CRUD_PP_PELANGGARAN,
  GET_DATA_PEGAWAI_KONTRAK,
  UPDATE_DATA_PRIBADI_DRH,
  GET_KELOMPOK_TALENTA,
  POST_SYNC_SIANTER_ASSESSMENT,
  GET_STATUS_SYNC_SIANTER_ASSESSMENT,
  GET_PREDIKAT_EKINERJA,
  GET_LIST_PENDIDIKAN_ID,
  GET_LIST_PRODI_BY_PENDIDIKAN,
  GET_LIST_GOLONGAN,
  GET_LIST_ESELON,
  GET_LIST_TIPE_JABATAN,
  GET_REKAPITULASI_PEGAWAI,
  GET_LIST_TIPE_REKAP,
  GET_LIST_JABFUNG,
  GET_LIST_GAJI,
  GET_CREATE_DATA_TUGAS_IZIN_BELAJAR,
  GET_CREATE_PEGAWAI_AKAN_PENSIUN,
  GET_CREATE_DATA_UJIAN_DINAS,
  DOWNLOAD_LAPORAN,
  GET_LAPORAN_GRAFIK,
  GET_CREATE_DATA_ANAK_BY_NIP,
  UPDATE_DELETE_DATA_ANAK_BY_NIP,
  UPDATE_PEGAWAI_KONTRAK,
  GET_OPTION_SHIFT,
  GET_LIST_TIM_KERJA,
  GET_CREATE_SEKOLAH,
  GET_DELETE_SEKOLAH,
  GET_UPDATE_SEKOLAH,
  GET_LIST_TINGKAT_PENDIDIKAN,
  UPDATE_PEGAWAI_KONTRAK_PENDIDIKAN,
  GET_LIST_AKTIVITAS_GENERAL,
  GET_LIST_ANGGOTA_TIM_KERJA,
  CRUD_PENDIDIKAN_INFORMAL,
  CRUD_DIKLAT_KURSUS_PEGAWAI,
  CRUD_CLTN,
  GET_OPTION_JURUSAN,
  GET_OPTION_SEKOLAH,
  CRUD_DIKLAT,
  GET_JENIS_DIKLAT_OPTION,
  GET_KATEGORI_DIKLAT_OPTION,
  GET_ESELON_OPTION,
  CRUD_JABATAN_ADMIN,
  GET_PEGAWAI_PENSIUN_OPTION,
  CREATE_ADMINISTRASI_MUTASI_PENSIUN_WAFAT,
  GET_LIST_PEGAWAI_ROLE,
  GET_LIST_MONITORING_OPERATOR,
  GET_SLKS_DASHBOARD,
  GET_LIST_PEGAWAI_SLKS,
  GET_DETAIL_UPT_DASHBOARD,
  GET_LIST_MENUS,
  ADD_GROUP_MENU,
  GET_LAPORAN_JUMLAH_JABATAN_UNIT,
  GET_LIST_PEGAWAI_LAPORAN_JUMLAH_JABATAN_UNIT,
  GET_OPTION_BIDANG_KEAHLIAN,
  READ_CREATE_PEGAWAI_KEAHLIAN,
  GET_MARKER_MAPS_UPT,
  GET_DASHBOARD_V2,
  GET_DASHBOARD_PEGAWAI_ESELON_1,
  GET_CREATE_KATEGORI_ASN_V2,
  GET_OPTION_PROGRAM_KERJA,
  GET_OPTION_STATUS_PROGRAM_KERJA,
  GET_OPTION_INTERVENSI_PROGRAM_KERJA,
  CRUD_LIST_PROGRAM_KERJA,
  ADD_ATTACHMENT_PROGRAM_KERJA,
  GET_DASHBOARD_PROGRAM_KERJA,
  EXPORT_DATA_MONITORING,
  EXPORT_DATA_MONITORING_ALL,
  GET_LIST_PROGRESS_MONITORING_ALL,
  UPLOAD_ATTACHMENT_PEGAWAI_KEAHLIAN,
  GET_LIST_PEGAWAI,
  UPDATE_MANUAL_DATA_DRH_PEGAWAI,
  UPDATE_MANUAL_DOKUMEN_DRH_PEGAWAI,
  EXPORT_DATA_LAPORAN,
  GET_LIST_PENILAIAN,
  GET_LIST_QUESTIONS,
  SUBMIT_PENILAIAN,
  GENERATE_PENILAIAN,
  CRUD_QUESTIONS,
  GET_DASHBOARD_ME,
  GET_DASHBOARD_ADMIN,
  GET_LIST_REPORT_PROSES,
  GET_DETAIL_REPORT_PROSES,
  GET_LIST_PEGAWAI_BY_STATUS_PENILAIAN,
  GET_LIST_REPORT_REKAP,
  GET_DETAIL_ASSESSMENT,
  GET_OPTION_INDIKATOR_ASSESSMENT,
  GET_LIST_HISTORI_GENERATE,
  EXPORT_LIST_REPORT_REKAP,
  EXPORT_LIST_REPORT_PROSES,
  GET_LIST_PROGRES_EXPORT,
  GET_LIST_ROLE_AKSES,
  UPDATE_ROLE_AKSES,
  GET_LIST_RELATIONS,
  GET_UPDATE_DETAIL_RELATION,
  GET_OPTION_ROLE,
  GET_OPTION_PEGAWAI_360,
  GET_OPTION_ROLE_PENILAI,
  CRUD_QUARTER,
  UPLOAD_CSV_PEGAWAI_ASN,
  GET_OPTION_TIM_KERJA_CATEGORY,
  GET_OPTION_ASSESSMENT,
  GET_OPTION_STATUS_PEGAWAI,
  UPDATE_STATUS_PEGAWAI,
  GET_STATUS_PEGAWAI_BY_NIP,
  GET_PIMPINAN_TIM_KERJA,
  GET_DASHBOARD_PRESENSI,
}
